const TOTAL_STARS = 3

const GRADED_XP_THRESHOLDS = [
  { maxXp: 25, stars: 0 },
  { maxXp: 50, stars: 1 },
  { maxXp: 75, stars: 2 },
  { maxXp: Infinity, stars: 3 },
] as const

export interface StarOnLessonArrayWithLearnProgresses {
  type: 'learn_progresses_array'
  learnProgresses: { status: string }[]
  lessonModuleData: { lessons: { id: string }[] }
}

export interface StarOnLessonArrayWithGradedXp {
  type: 'graded_xp'
  gradedXp: number
}

export type StarOnLessonArrayProps = StarOnLessonArrayWithLearnProgresses | StarOnLessonArrayWithGradedXp

/**
 * Creates an array of star objects based on lesson progress or graded XP
 * Each star has isFilled, isMiddle, and index properties
 */
export function starOnLessonArray(props: StarOnLessonArrayProps) {
  const totalStarEarned = calculateTotalStarsEarned(props)
  return createStarArray(totalStarEarned)
}

function calculateTotalStarsEarned(props: StarOnLessonArrayProps): number {
  if (props.type === 'learn_progresses_array') {
    const completedLessons = props.learnProgresses.filter(
      (learnProgress) => learnProgress.status === 'COMPLETED',
    ).length

    const totalLessons = props.lessonModuleData.lessons.length
    const completionRatio = completedLessons / totalLessons

    return Math.floor(completionRatio * TOTAL_STARS)
  }

  // props.type === 'graded_xp'
  const threshold = GRADED_XP_THRESHOLDS.find((t) => props.gradedXp <= t.maxXp)
  return threshold?.stars ?? 0
}

function createStarArray(totalStarEarned: number) {
  const middleIndex = Math.floor(TOTAL_STARS / 2)

  return Array.from({ length: TOTAL_STARS }, (_, index) => ({
    isFilled: index < totalStarEarned,
    isMiddle: index === middleIndex,
    index,
  }))
}

export type StarOnLessonArrayResponse = ReturnType<typeof starOnLessonArray>
